/**
 * @desc 财务收支应用表保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  params: API.basics.financeAccount.save.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/financeAccount/save`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
